import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { Capacitor } from "@capacitor/core";
import { App as CapacitorApp } from "@capacitor/app";

const connectionString = process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING;

// null when connectionString isn't set (e.g. local dev) so telemetry is a no-op
export const appInsights = connectionString
    ? new ApplicationInsights({
          config: {
              connectionString,
              enableAutoRouteTracking: true,
              disableAjaxTracking: false,
              excludeRequestFromAutoTrackingPatterns: [/\/health/],
              // cost: sample telemetry (task 888); applies to all item types, including exceptions
              samplingPercentage: 20,
              autoTrackPageVisitTime: false,
          },
      })
    : null;

if (appInsights) {
    appInsights.loadAppInsights();

    // tag every telemetry item with the running platform so web/iOS/Android can be told apart in Azure
    appInsights.addTelemetryInitializer((item) => {
        item.data = item.data || {};
        item.data.platform = Capacitor.getPlatform();
    });

    // native apps are backgrounded rather than unloaded, so beforeunload-based flushing never fires
    if (Capacitor.isNativePlatform()) {
        CapacitorApp.addListener("appStateChange", ({ isActive }) => {
            if (!isActive) {
                appInsights.flush();
            }
        });
    }
}
